import type { Components, CssVarsTheme } from '@mui/material/styles';

const styleOverrides: NonNullable<
  Components<CssVarsTheme>['MuiStack']
>['styleOverrides'] = {
  root: () => ({
    '.MuiButtonBase-root > .MuiChip-root > .MuiChip-label': {
      overflow: 'auto',
      textOverflow: 'unset',
    },

    '.MuiIconButton-root': {
      alignSelf: 'center',
    },
  }),
};

const MuiStack: Components<CssVarsTheme>['MuiStack'] = {
  styleOverrides,
};

export default MuiStack;
